import styled from "styled-components/macro";
import theme from "../theme";
import { colorState, typography } from "../../Foundation";

interface RowProps {
    isSelected: boolean;
}

export const Styles = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex: 1;
    position: relative;
`;

export const Checkbox = styled.input.attrs(() => ({
    type: "checkbox"
}))`
    padding: 0.5 rem;
    width: 18px;
    height: 18px;
    border: 1px solid #707070;
    border-radius: 4px;
    appearance: none;
    position: relative;

    &:checked {
        background-color: ${(props): string => props.theme.colors.primary.main.backgroundColor};
    }

    &:checked::after {
        content: "";
        position: absolute;
        left: 5px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`;

export const TableBodyRow = styled.tr<RowProps>`
    background-color: ${(props: RowProps): string =>
        props.isSelected ? theme.colors.primary.main.backgroundColor : "transparent"};
    border: 1px solid transparent;
    border-bottom: none;

    td {
        color: ${(props: RowProps): string => (props.isSelected ? "white" : "#6C7384")};
    }

    :nth-child(even) {
        background-color: ${(props: RowProps): string =>
            props.isSelected ? theme.colors.primary.main.backgroundColor : "#fafafa"};
    }

    &:hover {
        border: 1px solid ${theme.colors.primary.main.backgroundColor};
        background-color: ${(props: RowProps): string => {
            if (props.isSelected) {
                return theme.colors.primary.main.backgroundColor;
            }

            return "#fafafa";
        }};
        color: ${(props: RowProps): string => {
            if (props.isSelected) {
                return "black";
            }

            return "#6C7384";
        }};
    }
`;

export const TableThead = styled.thead`
    background-color: #e6e6e6;
    position: sticky;
    top: 0;
    z-index: 1;
`;

export const TableWrapper = styled.table`
    width: 100%;
    background-color: white;

    thead,
    tbody {
        th,
        td {
            border: 1px solid ${colorState.border.default.secondary};
            font-size: 14px;
            padding: 0 1rem;
        }
    }

    thead {
        background-color: white;

        tr {
            height: 56px;
        }

        th {
            font-weight: ${typography.weight.medium};
            color: ${colorState.text.primary};
            letter-spacing: 0.24px;
            position: relative;
            background-color: ${colorState.surface.default.secondary};
            white-space: nowrap;

            .table-header {
                gap: 0.5rem;
            }

            img {
                padding-left: 0;
            }

            .filter-icon {
                cursor: pointer;
                padding: 3px 5px;
                border-radius: 3px;
                position: relative;

                &::after {
                    display: none;
                    content: " ";
                    position: absolute;
                    left: 50%;
                    bottom: -13px;
                    transform: translate(-50%, 0);
                    border-top: none;
                    border-right: 8px solid transparent;
                    border-left: 8px solid transparent;
                    border-bottom: 8px solid
                        ${(props): string => props.theme.colors.primary.dark.color};
                }

                &:has(> .showArrow)::after {
                    display: block;
                }
            }

            .filter-icon:hover {
                background-color: #f0f0f0;
            }
        }
    }

    tbody {
        td {
            padding: 1rem;
        }

        td p {
            font-weight: 400;
            min-width: fit-content;
            max-width: 600px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 0;
        }

        .no-data-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 24px;
            font-weight: 600;
            width: 100%;
            overflow: auto;
            text-align: center;
        }
    }
`;

export const TableInfo = styled.div`
    font-size: 14px;
    font-weight: normal;
    color: #656565;
    display: flex;
    justify-content: start;
    align-items: center;
`;
